module.exports = __webpack_public_path__ + "static/media/quiz1.5f4e2ee2.png";